<button class="flex flex-col h-full border border-grey-200 rounded-md" (click)="handleCardClick(item)">
  <div class="flex justify-center bg-grey-50 p-4 pb-0 rounded-t-md">
    <div class="w-full aspect-square overflow-hidden rounded-t-md">
      <img
        class="block w-full h-full object-contain"
        [src]="item.thumbnail.public_asset_url"
        alt=""
      >
    </div>
  </div>
  <div class="flex items-center justify-between text-sm text-black mt-4 p-4 pt-0">
    <span class="flex-1">{{ item.title | truncate: 30 }}</span>
    @if (!item.is_confidential) {
      <i class="pi pi-download text-grey-600 !text-[15px] !font-bold ml-2 cursor-pointer" tabindex="0" role="button" (click)="handleDownload(item, $event)"></i>
    }
  </div>
</button>